var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWorld = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.667A8.336 8.336 0 0 0 1.667 10c0 4.6 3.733 8.333 8.333 8.333S18.334 14.6 18.334 10 14.6 1.667 10 1.667m-.833 14.941A6.657 6.657 0 0 1 3.334 10c0-.517.066-1.008.175-1.492L7.5 12.5v.833C7.5 14.25 8.25 15 9.167 15zm5.75-2.116a1.653 1.653 0 0 0-1.583-1.159H12.5v-2.5a.836.836 0 0 0-.833-.833h-5V8.333h1.667a.836.836 0 0 0 .833-.833V5.833h1.667c.916 0 1.666-.75 1.666-1.666v-.342c2.442.992 4.167 3.383 4.167 6.175a6.631 6.631 0 0 1-1.75 4.492"
  })));
};
export default SvgWorld;